module.exports = __webpack_public_path__ + "img/arrow.e9c60650.svg";